import { ReturnBlock } from "../ReturnBlock";

/**
 * A constant value block (essentially a primitive). Takes some value that does not change
 * like a string or a number.
 */
export class ConstBlock extends ReturnBlock {
    value;

    /**
     * Constructor
     * @param value value of the constant
     */
    constructor(id: string, value: any){
        super(id)
        this.value = value;
    }

    /**
     * Returns the value of the const block.
     * @param varEnv variable environment
     */
    evalBlock(varEnv: Map<string, any>): any{
        return this.value;
    }
}